import { toast } from "react-toastify";

const notifyError = (erro) => {
    toast.error(`Falha: ${erro}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

const notifySuccess = (message) => {
    toast.success(`Sucesso: ${message}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

const notifyWarning = (message) => {
    toast.warning(`Atenção: ${message}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

export { notifyError, notifySuccess, notifyWarning }